import { render } from "./Playbook.vue?vue&type=template&id=2f63f271&scoped=true"
import script from "./Playbook.vue?vue&type=script&lang=js"
export * from "./Playbook.vue?vue&type=script&lang=js"

import "./Playbook.vue?vue&type=style&index=0&id=2f63f271&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f63f271"]])

export default __exports__